var React = require('react');

function FreebiesHuntLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M70 84V73L126 73V153L0 145.911V73L51 73V84H70Z","key":0}),React.createElement("path",{"d":"M0 50.7215C0 22.7577 22.3858 0.0886078 50 0.0886078H76C103.614 0.0886078 126 22.7577 126 50.7215V67.9367H70V50.7215H51V67.9367H0V50.7215Z","key":1}),React.createElement("path",{"d":"M90 0H191.448C206.463 15.1321 209.733 25.4359 208.873 46.1791L135.567 68C135.567 39.5821 129.667 2.02985 90 0Z","key":2}),React.createElement("path",{"d":"M136 72.5L209 52V123.5L136 152.5V72.5Z","key":3})]);
}

FreebiesHuntLogo.defaultProps = {"width":"209","height":"153","viewBox":"0 0 209 153"};

module.exports = FreebiesHuntLogo;

FreebiesHuntLogo.default = FreebiesHuntLogo;
